import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SingleTableModel } from '../models/singleTableModel';
import { ExcelJson } from '../models/excelData';
import { TenantsService } from '../services/tenants.service';
import { AuthService } from '../services/auth.service';
import { ExportService } from '../services/export.service';
import { ErrorService } from '../services/error.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-tenants',
  templateUrl: './tenants.component.html',
  styleUrls: ['./tenants.component.css'],
  standalone: false
})
export class TenantsComponent implements OnInit {
  newTenant = new SingleTableModel('', '', '', '', true, 'tenant', '', '', '', '', '', 0, '', '', '', localStorage.getItem('UserName') ?? '','');
  searchTenant = new SingleTableModel('', '', '', '', true, 'tenant', '', '', '', '', '', 0, '', '', '', localStorage.getItem('UserName') ?? '','');
  tenants: SingleTableModel[] = [];
  filteredTenants: SingleTableModel[] = [];
  action: string = 'view';
  p: number = 1;
  errorMessage: string = '';
  isAdminUser: boolean = false;
  isTenantUser: boolean = false;
  isLoading: boolean = true;
  @ViewChild('tenantDetails') tenantDetails!: ElementRef;
  fileName: string = '';

  constructor(private tenantsService: TenantsService, private authService: AuthService, private exportService: ExportService, private errorService: ErrorService, private datePipe: DatePipe) {

  }
  ngOnInit(): void {
    this.isAdminUser = this.authService.IsAdminUser$.value;
    this.isTenantUser = this.authService.IsTenantUser$.value;
    if (this.isAdminUser) {
      this.getAllTenants();
    }
    else {
      this.getUserTenants();
    }
    
  }

  updateAction(action: string) {
    this.action = action;
  }

  searchTenants() {
    if (this.tenants.length > 0) {
      this.filteredTenants = [];

      this.filteredTenants.push(...this.tenants.filter((x) =>
        (x.email?.toLowerCase().includes(this.searchTenant.email?.toLowerCase()) || this.searchTenant.email == '')
        && (x.name?.toLowerCase().includes(this.searchTenant.name?.toLowerCase()) || this.searchTenant.name == '')
        && (x.id?.toLowerCase().includes(this.searchTenant.id?.toLowerCase()) || this.searchTenant.id == '')
      ));
      this.p = 1;
    }
  }

  getAllTenants1() {
    this.tenantsService.getAllTenantsWithLimit(localStorage.getItem('accessKey') ?? '', 10, '', '').subscribe((data) => {
      this.tenants = data;
      this.filteredTenants = data;
    }, (error) => {
      this.errorMessage = this.errorService.alertError(error);
    });
  }

  getAllTenants() {
    this.tenantsService.getAllTenants().subscribe((tenants) => {
      if (tenants.hasOwnProperty('message')) {
        this.errorMessage = tenants.message;
      }
      else {
        if (tenants.hasOwnProperty('Item')) {
          this.tenants = [];
          this.filteredTenants = [];
          this.tenants.push(tenants.Item);
          this.filteredTenants.push(tenants.Item);
        }
        else {
          this.tenants = tenants.Items;
          this.filteredTenants = tenants.Items;
        }
      }
      this.isLoading = false;
    }, (error) => {
      this.isLoading = false;
      this.errorMessage = this.errorService.alertError(error);
    });
  }

  getUserTenants() {
    this.tenantsService.getUserTenants(this.authService.AccessDetails$.value.AccessAssociation).subscribe((tenants) => {
      if (tenants.hasOwnProperty('message')) {
        this.errorMessage = tenants.message;
      }
      else {
        if (tenants.hasOwnProperty('Item')) {
          this.tenants = [];
          this.filteredTenants = [];
          this.tenants.push(tenants.Item);
          this.filteredTenants.push(tenants.Item);
        }
        else {
          this.tenants = tenants;
          this.filteredTenants = tenants;
        }
      }
      this.isLoading = false;
    }, (error) => {
      this.isLoading = false;
      this.errorMessage = this.errorService.alertError(error);
    });
  }

  onSubmit(updatedAction: string) {
  }

  refreshTenants(value: string) {
    this.searchTenant = new SingleTableModel('', '', '', '', true, '', '', '', '', '', '', 0, '', '', '', localStorage.getItem('UserName') ?? '','');
    this.resetNewTenant();
    if (value == 'refresh') {
      //this.isLoading = false;
      if (this.isAdminUser) {
        this.getAllTenants();
      }
      else {
        this.getUserTenants();
      }
      this.updateAction('view');
    }
    else if (value == 'reload') {
      this.filteredTenants = [];
      this.filteredTenants.push(...this.tenants);
      this.updateAction('view');
    }
    else if (value == 'startLoading') {
      this.isLoading = true;
    }
    else if (value == 'stopLoading') {
      this.isLoading = false;
    }
  }

  resetNewTenant() {
    this.newTenant.email = '';
    this.newTenant.id = '';
    this.newTenant.name = '';
  }

  exportElmToExcel(): void {
    this.exportService.exportTableElmToExcel(this.tenantDetails, 'tenant_details');
  }

  exportToCsv(): void {
      let exportRows: SingleTableModel[] = [];
      this.filteredTenants.forEach(tenant => {
        exportRows.push(new SingleTableModel(tenant.id, tenant.transactionId, tenant.email, tenant.flow_id, tenant.isActive, tenant.recordType, tenant.accessKey, tenant.name, tenant.transactionJSON, tenant.tsn, this.datePipe.transform(new Date(tenant.updateDate), 'yyyy-MM-dd HH:mm:ss')!, tenant.updateEpochTime, '', '', '','',''));
      });

    this.fileName = this.filteredTenants.length > 1 ? 'Tenant_Details_' + this.datePipe.transform(Date.now(), 'yyyy-MM-dd HH:mm:ss') : 'Tenant_Details_' + this.filteredTenants[0].id + '_' + this.datePipe.transform(Date.now(), 'yyyy-MM-dd HH:mm:ss');

    this.exportService.exportToCsv(exportRows, this.fileName, ['id', 'name', 'accessKey', 'isActive', 'updateDate'],
      ['Tenant Id', 'Name', 'AccessKey', 'Active', 'Modified Date']);
  }

  exportToExcel(): void {
    const edata: Array<ExcelJson> = [];
    const udt: ExcelJson = {
      data: [
        //{ A: 'Tenant Details' }, // title
        { A: 'TenantId', B: 'Name', C: 'AccessKey', D: 'Active', E: 'Modified Date' }, // table header
      ],
      skipHeader: true
    };
    udt.data.push(this.filteredTenants);
    this.filteredTenants.forEach(tenant => {
      udt.data.push({
        A: tenant.id,
        B: tenant.name,
        C: tenant.accessKey,
        D: tenant.isActive,
        E: this.datePipe.transform(new Date(tenant.updateDate), 'yyyy-MM-dd HH:mm:ss')
      });
    });
    edata.push(udt);
    this.fileName = this.filteredTenants.length > 1 ? 'Tenant_Details_' + this.datePipe.transform(Date.now(), 'yyyy-MM-dd HH:mm:ss') : 'Tenant_Details_' + this.filteredTenants[0].id + '_' + this.datePipe.transform(Date.now(), 'yyyy-MM-dd HH:mm:ss');
    this.exportService.exportJsonToExcel(edata, this.fileName);
  }


}
